import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { DraftBox } from './DraftBox/DraftBox';
import DraftModalContent from './DraftModal/DraftModalContent';
import './DraftModal.css';

import { ProjectViewConsumer } from '../../../containers/ProjectView/ProjectView.context';

const DraftModal = ({
  project: { drafts, manager, client, status },
  onSubmit,
}) => {
  const [isDraftModalOpen, setDraftModalOpen] = useState(false);

  const renderDrafts = (setDraftModalOpen, isManagerUser) => {
    return drafts.map((draft, index) => (
      <DraftBox
        draft={draft}
        key={index.toString()}
        openDraftPopup={setDraftModalOpen}
        isManagerUser={isManagerUser}
        addMarginBottom={index < (drafts.length -1)}
        disabled={drafts[index].status == "not_started" && index > 0}
      />
    ))
  }

  return (
    <ProjectViewConsumer>
      {({ user: { type } }) => {
        const isManagerUser = includes(['Manager', 'Master'], type);

        return (
          <Fragment>
            <div className="col-12 col-lg-4 text-left text-lg-right mb-3 mb-lg-0">
              <DraftModalContent
                drafts={drafts}
                user={client}
                onSubmit={onSubmit}
                onCloseModal={() => setDraftModalOpen(false)}
                initialOpen={isDraftModalOpen}
              />
            </div>
            <div className="col-12 col-lg my-4 mb-lg-2 d-flex">
              <div className="row">
                {renderDrafts(setDraftModalOpen, isManagerUser)}
              </div>
            </div>
          </Fragment>
        );
      }}
    </ProjectViewConsumer>
  );
};

DraftModal.propTypes = {
  project: PropTypes.shape({
    drafts: PropTypes.array,
  }),
  onSubmit: PropTypes.func,
};

export default DraftModal;



// WEBPACK FOOTER //
// ./src/components/ProjectView/DraftModal/DraftModal.js